import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import apiClient, { getErrorMessage } from '../../api/client';
import { useToast } from '../../hooks/useToast';
import { FiCheck, FiX } from 'react-icons/fi';

const PlatformPendingPayments = () => {
  const { success, error: showError } = useToast();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refNotes, setRefNotes] = useState({});

  const loadAll = () => {
    setLoading(true);
    apiClient.get('/subscriptions/payments/pending')
      .then(({ data }) => setPayments(data.data))
      .catch((err) => showError(getErrorMessage(err, 'Could not load pending payments')))
      .finally(() => setLoading(false));
  };

  useEffect(loadAll, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleConfirm = async (paymentId, status) => {
    if (status === 'failed' && !window.confirm('Mark this payment as failed? The customer will need to try again.')) return;
    try {
      await apiClient.patch(`/subscriptions/payments/${paymentId}/confirm-bank-transfer`, {
        status,
        providerTransactionRef: refNotes[paymentId] || undefined,
      });
      success(status === 'succeeded' ? '✅ Payment confirmed' : '✅ Payment marked failed');
      loadAll();
    } catch (err) { showError(getErrorMessage(err, 'Could not update payment')); }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Pending Payments</h1>
        <p style={{ color: '#6b7280', margin: '0.25rem 0 0 0' }}>
          Bank transfer payments awaiting manual confirmation against your real bank statement — {payments.length} pending
        </p>
      </div>

      <div className="table-container" style={{ background: 'white', borderRadius: '8px', overflow: 'hidden' }}>
        <table className="data-table">
          <thead><tr><th>Attempted</th><th>Amount</th><th>Reference on file</th><th>Confirm Ref (optional)</th><th>Actions</th></tr></thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: '2rem' }}>Loading...</td></tr>
            ) : payments.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>Nothing pending right now</td></tr>
            ) : payments.map((p) => (
              <tr key={p.id}>
                <td>{new Date(p.attemptedAt).toLocaleString()}</td>
                <td style={{ fontWeight: 600 }}>£{Number(p.amount).toFixed(2)}</td>
                <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{p.providerTransactionRef || '—'}</td>
                <td>
                  <input
                    placeholder="Bank ref (optional)"
                    value={refNotes[p.id] || ''}
                    onChange={(e) => setRefNotes((prev) => ({ ...prev, [p.id]: e.target.value }))}
                    style={{ padding: '0.4rem', width: '160px' }}
                  />
                </td>
                <td>
                  <div className="actions">
                    <button className="action-icon edit" title="Confirm received" onClick={() => handleConfirm(p.id, 'succeeded')}>
                      <FiCheck size={16} />
                    </button>
                    <button className="action-icon delete" title="Mark failed" onClick={() => handleConfirm(p.id, 'failed')}>
                      <FiX size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
};

export default PlatformPendingPayments;